import axios from "axios";

const BASE_URL = "https://medizenapi.ir/v1";

// ۱. دریافت مراکز درمانی
export const getCenters = async (params) => {
  try {
    // حذف مقادیر خالی قبل از ارسال برای جلوگیری از بروز خطا
    const cleanParams = Object.keys(params).reduce((acc, key) => {
      const value = params[key];
      if (value !== null && value !== undefined && String(value).trim() !== "") {
        acc[key] = value;
      }
      return acc;
    }, {});

    const response = await axios.get(`${BASE_URL}/center/getCenters`, {
      params: cleanParams,
    });
    return response.data;
  } catch (error) {
    console.error("خطا در دریافت لیست مراکز درمانی:", error);
    throw error;
  }
};

// ۲. دریافت لیست شهرها
export const getCities = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/location/getCities?country_id=103`);
    
    // تبدیل ایمن پاسخ به آرایه (پشتیبانی از آبجکت تکی یا آرایه)
    const rawData = response.data?.data || response.data;
    const dataArray = Array.isArray(rawData) ? rawData : (rawData ? [rawData] : []);

    return dataArray.map((item) => ({
      id: item.id,
      title: item.name, // در ساختار شهرها، فیلد نام name است
    }));
  } catch (error) {
    console.error("خطا در دریافت لیست شهرها:", error);
    return [];
  }
};

// ۳. دریافت لیست دسته‌بندی‌ها
export const getCategories = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/center/getCategories`);
    
    // تبدیل ایمن پاسخ به آرایه (پشتیبانی از آبجکت تکی یا آرایه)
    const rawData = response.data?.data || response.data;
    const dataArray = Array.isArray(rawData) ? rawData : (rawData ? [rawData] : []);

    return dataArray.map((item) => ({
      id: item.id,
      title: item.title,
    }));
  } catch (error) {
    console.error("خطا در دریافت دسته‌بندی‌ها:", error);
    return [];
  }
};

// ۴. دریافت لیست گروه‌های درمانی
export const getGroups = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/center/getGroups`);
    
    // تبدیل ایمن پاسخ به آرایه (پشتیبانی از آبجکت تکی یا آرایه)
    const rawData = response.data?.data || response.data;
    const dataArray = Array.isArray(rawData) ? rawData : (rawData ? [rawData] : []);

    return dataArray.map((item) => ({
      id: item.id,
      title: item.title,
    }));
  } catch (error) {
    console.error("خطا در دریافت گروه‌های درمانی:", error);
    return [];
  }
};

// ۵. دریافت لیست بیمه‌ها
export const getInsurances = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/doctor/getInsurances`);
    
    // تبدیل ایمن پاسخ به آرایه (پشتیبانی از آبجکت تکی یا آرایه)
    const rawData = response.data?.data || response.data;
    const dataArray = Array.isArray(rawData) ? rawData : (rawData ? [rawData] : []);

    return dataArray.map((item) => ({
      id: item.id,
      title: item.title,
    }));
  } catch (error) {
    console.error("خطا در دریافت بیمه‌ها:", error);
    return [];
  }
};

// ۶. دریافت جزئیات یک مرکز درمانی بر اساس شناسه
export const getCenterById = async (id) => {
  try {
    
    if (!id) {
      throw new Error("شناسه مرکز (id) الزامی است.");
    }
    const response = await axios.get(`${BASE_URL}/center/getCenter`, {
      params: { id: id } ,
      
    });
    console.log(response.data);
    return response.data;
    
  } catch (error) {
    console.error(`خطا در دریافت جزئیات مرکز درمانی` );
    throw error;
  }
  
};

// ۷. دریافت اطلاعات یک پزشک بر اساس شناسه پزشک
export const getDoctorById = async (doctorId) => {
  try {
    if (!doctorId) {
      throw new Error("شناسه پزشک (doctor_id) الزامی است.");
    }
    const response = await axios.get(`${BASE_URL}/doctor/getDoctor`, {
      params: { doctor_id: doctorId },
    });
    return response.data;
  } catch (error) {
    console.error(`خطا در دریافت اطلاعات پزشک با شناسه ${doctorId}:`, error);
    throw error;
  }
};